import { Button, Modal } from "antd";
import parse from "html-react-parser";
import React from "react";
import icon from "../../../assets/images/error-modal-icon.png";
import FireRemoteService from "../../../core/services/fire-remote";
import "./error-modal.scss";

interface IProps {
  isVisible: boolean;
  title?: string;
  text?: string;
  buttonText?: string;
  callbackOk: () => void;
  callbackCancel: () => void;
}

const ModalError = (props: IProps) => {

  return (
    <Modal
      className="error-modal"
      maskStyle={{ backdropFilter: "blur(8px)" }}
      visible={props.isVisible}
      centered
      closable={false}
      footer={false}
      onCancel={props.callbackCancel}
    >
      <div id="error-modal-body">

        <img className="icon" src={icon} alt="error" />

        <p className="title">
          {
            props.title
              ? props.title
              : parse(FireRemoteService.getStringValue(FireRemoteService.errorPopupTitle))
          }
        </p>

        <p className="text">
          {
            props.text
              ? props.text
              : parse(FireRemoteService.getStringValue(FireRemoteService.errorPopupText))
          }
        </p>

        <Button
          className="modal-button primary"
          onClick={props.callbackOk}
        >
          {
            props.buttonText
              ? props.buttonText
              : parse(FireRemoteService.getStringValue(FireRemoteService.errorPopupButton))
          }
        </Button>

      </div>
    </Modal>
  );
}

export default ModalError;
